export default __webpack_public_path__ + "static/media/facebook.c4830c53.jpg";